import { z } from 'zod';

export const discountTypeSchema = z.enum(['Const', 'Percent']);

export type DiscountTypeSchema = z.infer<typeof discountTypeSchema>;
